var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interaction-card-container"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imagePath,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }